import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import StickiestModal from '../components/stickiest/StickiestModal';

export default () => {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (discussion.canSticky() && (discussion.canStickiest() || discussion.canTagSticky())) {

      items.add(
        'stickiest',
        Button.component(
          {
            icon: 'fas fa-thumbtack',
            onclick: () => app.modal.show(StickiestModal, { discussion }),
          },
          app.translator.trans('the-turk-stickiest.forum.discussion_controls.sticky_button')
        )
      );

     // Remove the original sticky button
     $('.DiscussionListItem .Dropdown-menu').find('.item-sticky').remove();
    }
  });
}
